import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import UpdatePlan from './UpdatePlan';
import { INITIAL_STATE } from '../constants';
import PlanDetails from './PlanDetails';

function Plan() {
  const [filter, setFilter] = useState(INITIAL_STATE || []);
  return (
    <Routes>
      <Route index element={<PlanDetails />} />
      <Route
        path="update-plan"
        element={<UpdatePlan filter={filter} setFilter={setFilter} />}
      />
    </Routes>
  );
}

export default React.memo(Plan);
